import React from "react";

function useMatchListScroll(ref, isYearly) {
  React.useEffect(() => {
    if (ref.current && isYearly) {
      ref.current.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    }
  }, [ref, isYearly]);

  return null;
}

export default useMatchListScroll;
